export type Nullable<T> = T | null | undefined;

export function isNotNil<T>(nullable: Nullable<T>): nullable is T {
  return nullable !== null && nullable !== undefined;
}
